import React, { useState, useEffect } from "react";
import classNames from "classnames";

import FocusTrap from "../FocusTrap";

import styles from "./Dialog.module.css";

type Props = {
  name: string;
  children: JSX.Element[] | JSX.Element | string;
  isOpen?: boolean;
  onClose?: () => void;
};

const Dialog: React.FC<Props> = ({ name, children, isOpen, onClose }) => {
  const uniqueName = `${name.toLowerCase().replace(" ", "-")}--dialog`;

  // Wait for dialog to be fully visible before triggering focustrap
  const [animationFinished, setAnimationFinished] = useState(false);

  useEffect(() => {
    function trigger() {
      setAnimationFinished(true);
    }

    if (isOpen) {
      setTimeout(() => {
        trigger();
      }, 200);
    } else {
      setAnimationFinished(false);
    }
  }, [isOpen]);

  const dialogClass = classNames({
    [styles["dialog"]]: true,
    [styles["-open"]]: isOpen,
  });

  return (
    <div className={dialogClass}>
      <div className={styles.background} aria-hidden></div>
      <div className={styles.panel}>
        <FocusTrap
          onExit={onClose}
          visible={isOpen}
          active={isOpen && animationFinished}
          name={uniqueName}
          labelledby={`${uniqueName}-name`}
          describedby={`${uniqueName}-inner`}
        >
          <div className={styles.dialog}>
            <h1 className="sr" id={`${name}-name`}>
              {uniqueName}
            </h1>
            <div id={`${name}-inner`} className={styles.inner} role="document">
              <div className={styles.body}>{children}</div>
            </div>
          </div>
        </FocusTrap>
      </div>
    </div>
  );
};

export default Dialog;
